import { del, downloadApiFile, get, post, put } from '@/api/client'

const base = '/business/psi/warehouse'

export function getWarehouseList(params: WarehouseListParams) {
  return post<WarehouseListRes>(`${base}/getWarehouseList`, params)
}

function compactExportParams(params?: object) {
  const out: Record<string, unknown> = {}
  if (!params) return out
  Object.entries(params).forEach(([key, value]) => {
    if (key === 'page' || key === 'pageSize') return
    if (value === undefined || value === null || value === '') return
    out[key] = value
  })
  return out
}

export function exportWarehouseList(params?: WarehouseListParams) {
  return downloadApiFile(`${base}/exportWarehouseList`, {
    params: compactExportParams(params),
    filename: '仓库列表.xlsx',
  })
}

export function getWarehouseById(id: number, signal?: AbortSignal) {
  return get<WarehouseListItem>(`${base}/getWarehouseById`, { params: { id }, signal })
}

export function createWarehouse(data: SaveWarehouseReq) {
  return post<{ id: number; warehouseCode: string }>(`${base}/createWarehouse`, data)
}

export function updateWarehouse(data: SaveWarehouseReq & { id: number }) {
  return put<null>(`${base}/updateWarehouse`, data)
}

export function toggleWarehouseStatus(data: { id: number; status: WarehouseStatus }) {
  return put<null>(`${base}/toggleWarehouseStatus`, data)
}

export function deleteWarehouse(id: number) {
  return del<null>(`${base}/deleteWarehouse`, { params: { id } })
}

export function getLocationList(warehouseId: number) {
  return get<WarehouseLocationListRes>(`${base}/getLocationList`, { params: { warehouseId } })
}

export function createLocation(data: SaveWarehouseLocationReq) {
  return post<{ id: number }>(`${base}/createLocation`, data)
}

export function batchCreateLocations(data: BatchCreateWarehouseLocationsReq) {
  return post<{ count: number }>(`${base}/batchCreateLocations`, data)
}

export function updateLocation(data: SaveWarehouseLocationReq & { id: number }) {
  return put<null>(`${base}/updateLocation`, data)
}

export function toggleLocationStatus(data: { id: number; status: WarehouseStatus }) {
  return put<null>(`${base}/toggleLocationStatus`, data)
}

export function deleteLocation(id: number) {
  return del<null>(`${base}/deleteLocation`, { params: { id } })
}
